export default class User {
  constructor(data) {
    this.id = data && data.id ? data.id : 0;
    this.firstName = data && data.firstName ? data.firstName : '';
    this.lastName = data && data.lastName ? data.lastName : '';
    this.email = data && data.email ? data.email : '';
    this.avatarPath = data && data.avatarPath ? data.avatarPath : '';
    this.currency = data && data.currency ? data.currency : 'USD';
  }
}

export const userToApiMap = [
  ['id', 'id'],
  ['firstName', 'first'],
  ['lastName', 'last'],
  ['email', 'email'],
  ['avatarPath', 'avatarPath'],
  ['currency', 'currancy'],
];



// WEBPACK FOOTER //
// ./src/models/User.js